import React from "react";
import { connect } from "react-redux";
import SpecialCheck from "../components/SpecialCheck";
import Header from "../pages/Header";

import { makeStyles } from "@material-ui/core/styles";
import { changeName, changePhone } from "../modules/specialCheck";

const useStyles = makeStyles({
  root: {
    height: "100%",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: 10,
    paddingRight: 10,
  },
  checkRoot: { height: "85%" },
  checkRootBox: {
    maxWidth: 480,
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: 15,
    paddingRight: 15,
    paddingBottom: 10,
    fontSize: 14,
    height: "100%",
  },
  "@media screen and (min-width:600px)": {
    root: {
      maxWidth: 600,
      paddingLeft: "1%",
      paddingRight: "1%",
    },
    checkRootBox: {
      paddingLeft: 50,
      paddingRight: 50,
      paddingTop: 10,
      paddingBottom: 10,
    },
  },
});
function SpecialCheckContainer({ specialCheck, changeName, changePhone }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header title="특판 회원 포인트 조회" />
      <div className={classes.checkRoot}>
        <div className={classes.checkRootBox}>
          <SpecialCheck
            specialCheck={specialCheck}
            onChangeName={changeName}
            onChangePhone={changePhone}
          ></SpecialCheck>
        </div>
      </div>
    </div>
  );
}

// export default connect(
//   ({ specialCheck }) => ({
//     specialCheck,
//   }),
//   {
//     changeName,
//     changePhone,
//   }
// )(SpecialCheckContainer);

export default connect(
  ({ specialCheck }) => ({
    specialCheck,
  }),
  {
    changeName,
    changePhone,
  }
)(SpecialCheckContainer);
